module.exports = __webpack_public_path__ + "static/media/6.question.cef74834.mp4";